import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { api_params } from "./serviceUrls";
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

/*
   TEConnectivity Api Endpoints Service(Need to inject them where needed via DI[dependency injection])
*/

export class ApiService {
  BASE_URL = environment.BASE_URL;

  constructor(private http: HttpClient) { }

  registerUser(obj) {
    return this.http.post(api_params.REGISTER_HOST_URL, obj);
  }

  //Authentication
  loginUser(obj) {
    obj.projectId = 2;
    return this.http.post(api_params.LOGIN_HOST_URL, obj);
  }

  refreshToken(obj) {
      obj.projectId = 2;
      return this.http.post(api_params.REFRESH_TOKEN_HOST_URL, obj, {
        headers: new HttpHeaders({
          'X_API_KEY': 'sdf3rfew3ferf$dfvfrrg#dgsrr2342gdasewe&r'
        })
      });
    }

  logoutUser(body) {
    body.projectId = 2;
    return this.http.post(api_params.LOGOUT_HOST_URL, body);
  }

  forgotPassword(email: object) {
    return this.http.get(api_params.FORGOT_PASSWORD_HOST_URL +email);
  }

  verifyCode(code) {
    return this.http.get(api_params.VERIFY_CODE_HOST_URL +code);
  }

  sendInvite(body) {
    return this.http.post(api_params.SEND_INVITE_HOST_URL, body);
  }

  updateUser(body) {
    return this.http.put(api_params.UPDATE_USER_HOST_URL, body);
  }

  getDepartments() {
    return this.http.get(api_params.DEPARTMENT_LIST_HOST_URL);
  }

  getUserProfile() {
    return this.http.get(api_params.USER_PROFILE_HOST_URL);
  }

  clearData(type) {
    return this.http.put(api_params.CLEAR_DATA_HOST_URL+ type,{});
  }

  getMembers() {
    return this.http.get(api_params.GET_MEMBERS_HOST_URL);
  }

  removeMember(userId) {
    let obj = {
      id: userId
    };
    return this.http.post(api_params.REMOVER_MEMBER_HOST_URL,obj);
  }

  getBounties() {
    return this.http.get(api_params.GET_BOUNTIES_HOST_URL);
  }

  updateBounty(obj) {
    return this.http.put(api_params.UPDATE_BOUNTY_HOST_URL,obj);
  }

  getDeals() {
    return this.http.get(api_params.GET_DEALS_HOST_URL);
  }

  claimDeal(obj) {
    return this.http.post(api_params.CLAIM_DEAL_HOST_URL, obj);
  }

  getLeaderboard(type,rank) {
    return this.http.get(api_params.GET_LEADERBOARD_HOST_URL+'type='+type+'&rank='+rank+'&totalScore=all');
  }

  getDailychecksHiatory() {
    return this.http.get(api_params.GET_DAILY_CHECKS_HISTORY_HOST_URL);
  }

  getDealsHiatory() {
    return this.http.get(api_params.GET_DEALS_HISTORY_HOST_URL);
  }

  getBountiesHiatory() {
    return this.http.get(api_params.GET_BOUNTIES_HISTORY_HOST_URL);
  }

  getReviews() {
    return this.http.get(api_params.GET_REVIEWS_HOST_URL);
  }

  claimPoints(productId,points) {
    return this.http.put(api_params.CLAIM_POINTS_HOST_URL+'id='+productId+ '&points='+points , {});
  }

  getPlayProducts() {
    return this.http.get(api_params.GET_PLAY_PRODUCTS_HOST_URL);
  }

  getDailyChecks() {
    return this.http.get(api_params.GET_DAILY_CHECKS_HOST_URL);
  }

  updateDailyCheckProduct(obj) {
    return this.http.post(api_params.UPDATE_DAILY_CHECK_HOST_URL,obj);
  }

  getImpacts() {
    return this.http.get(api_params.GET_IMPACTS_HOST_URL);
  }

  getIndividualImpacts() {
    return this.http.get(api_params.GET_INDIVIDUAL_IMPACTS_HOST_URL);
  }

  transmitProduct(obj) {
    return this.http.post(api_params.TRANSMIT_PRODUCT_HOST_URL,obj);
  }

  adjustProduct(obj) {
    return this.http.put(api_params.ADJUST_PRODUCT_HOST_URL,obj);
  }

  rejectDeal(obj) {
    return this.http.post(api_params.REJECT_DEAL_HOST_URL, obj);
  }
}
